var api = "https://api.qingcigame.com";
var activeKey = '1d225901550ec55630e679bcea5b2f9b'; // 第六期

var user_id_arr = [];
const config = {
    account: "",
    channel: "",
    id: "",
    platform: "",
    area: "",
    game_id: 74,
    role_id: "",
    page_id: 11,
    token: ''
};
let bindParams = {};
let timer = null;
let wait = 60;

var filterData = '';
let jsonDataId = [
    { id: 35, xff: 62, zsf: 35 }, // 时光id对应的服务器
    { id: 67, xff: 25, zsf: 67 }, // 使魔id对应的服务器
    { id: 39, xff: 26, zsf: 39 }, // 蜗牛id对应的服务器
    { id: 33, xff: 42, zsf: 33 }, // 提灯id对应的服务器
    { id: 58, xff: 58, zsf: 69 }, // 仙剑id对应的服务器
    { id: 74, xff: 61, zsf: 74 }, // 小樱id对应的服务器2
    { id: 82, xff: 40, zsf: 82 }, // 刃心2id对应的服务器
    { id: 87, zsf: 87 }, // 刃心1id对应的服务器
    { id: 48, zsf: 48 }, // 超喵星id对应的服务器
    { id: 47, zsf: 47 }, // 骑士冲呀id对应的服务器
    { id: 50, zsf: 50 }, // 迷途之光id对应的服务器
]

var initialSlide = 0; //设置默认索引为0

var currentTime = new Date();
var specifiedTime = new Date('2025-01-28T10:00:00'); // 将此处替换为你的指定时间
var options = currentTime < specifiedTime ? ['瑞雪兆丰，暖意新春。完成祈愿任务，有机会抽取「暖意新春」全套满阶卡池，点击链接参与活动', '收获满满暖意，与我共赴新春。点击链接前往'] : ['瑞雪兆丰，暖意新春。完成祈愿任务，有机会抽取「暖意新春」全套满阶卡池，点击链接参与活动', '收获满满暖意，与我共赴新春。点击链接前往', '《魔卡少女樱：回忆钥匙》「暖意新春」梦幻卡池现已开启！参与活动有机会获取全套满阶卡池，快来看看吧！']
var shareText = options[Math.floor(Math.random() * options.length)];

var requestInterface = {};
var routerParams = {};
var awardNum = 0; // 可以领取的奖励数量
var gameNum = 0; // 游戏次数
var isBindRole = false;
let lastClickTime = 0; // 最后一次点击抽奖按钮时间
const cutdown = 1000;

var obj = {
    index: function() {
        this.isToken();
        this.onAdapt();
        this.indexBind(); // 首页按钮
        this.helpRecord(); // 帮助记录
        this.share(); // 分享
    },
    helpRecord: function() {
        routerParams = analysisParams(window.location.href);
        let strId = window.localStorage.getItem('helper_id');
        if (strId == null) return
        let user_id_arr = [...new Set(strId.split(",").map(Number))];
        // console.log(user_id_arr);
        // console.log(routerParams.helper_id)

        // 带帮助id则执行
        if (routerParams.helper_id !== undefined) {
            if (window.localStorage.getItem('helper_id') !== null) {
                // 帮助id是否包含在缓存中
                if (!window.localStorage.getItem('helper_id').includes(routerParams.helper_id)) {
                    // alert('不包含')
                    shareRecords();
                }
            }
        }

        function shareRecords() {
            requestInterface.countNum('小樱_第六期_移动端_通过复制链接点入');
            requestInterface.share({ helper_id: routerParams.helper_id });
            // 再次记录到缓存数组里
            user_id_arr.push(routerParams.helper_id);
            window.localStorage.setItem('helper_id', user_id_arr);
        }
    },
    onAdapt: function() {
        //小屏自适应
        const width = $(window).width();
        const height = $(window).height();
        const aspectRatio = Number((width / height).toFixed(3));
        // alert('aspectRatio:' + aspectRatio);
        // console.log('aspectRatio', aspectRatio);
        if (aspectRatio >= 0.63) {
            $('body').addClass('adapt-2');
        } else if (aspectRatio >= 0.585) {
            $('body').addClass('adapt-1');
        } else if (aspectRatio >= 0.5) {
            $('body').addClass('adapt-3');
        } else if (aspectRatio >= 0.4) {
            $('body').addClass('adapt-4'); //很长的机型
        }
    },
    isToken: function() {
        const params = analysisParams(window.location.href)
        let is_token = params.token;
        // 若没带token则默认非游戏登录
        if (is_token == undefined) {
            this.preloading(); // 预加载
            if (localStorage.getItem('token') !== null) {
                this.preloading(); // 预加载
                requestInterface.is_login(localStorage.getItem('token'));
                // setTimeout(function() {
                obj.onInit();
                // }, 500)
            }
        } else {
            // 存储token后重定向清除url中的token
            localStorage.setItem('token', is_token)
            window.location.href = window.location.origin + window.location.pathname;
        }
    },
    preloading: function() {
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {

            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".preloading #percent").html(parseInt(e.progress * 100));
            };
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.content').addClass('index-show');
            this.indexSwiper();
            $('.preloading').fadeOut();
            setTimeout(function() {
                $('.preloading').remove();
            }, 1000)
        }, this);
        queue.loadManifest([
            '/card-pool-6/images/mobile/preloading_bg-db9b8e6669.png',
            '/card-pool-6/images/mobile/index_bg-9c0874a9c4.png',
            '/card-pool-6/images/mobile/slogan-17c454c87b.png',
            '/card-pool-6/images/mobile/header_bg-674af7d22e.png'
        ]);
    },
    indexBind: function() {
        // 登陆相关绑定事件
        obj.loginEventBind();

        // 通用绑定事件
        $('.close-btn').on('click', function() {
            $('.popup').fadeOut();
        });

        $('.role-tab').on('click', '.btn', function() {
            requestInterface.countNum('小樱_第六期_移动端_点击往期页签');
            $(this).addClass('selected').siblings().removeClass('selected').parent('.role-tab').siblings('.role-list-content').children('.role-list-box').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.cg_popup .close_btn').on('click', function() {
            $('.cg_popup').fadeOut();
        });
        $('.wechat_btn').on('click', function() {
            $('.wechat_popup').fadeIn();
        });

        $('.enterprise_wechat_btn').on('click', function() {
            $('.enterprise_wechat_popup').fadeIn();
        });

        $('.wechat_box .confirm_btn').on('click', function() {
            $('.wechat_popup, .enterprise_wechat_popup').fadeOut();
        });

        $('.award_list_btn').on('click', function() {
            $('.award_list_popup').fadeIn();
            requestInterface.countNum('小樱_第六期_移动端_奖池列表');
        });
        $('.prize_btn').on('click', function() {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            $('.my_prize_popup').fadeIn();
            requestInterface.countNum('小樱_第六期_移动端_我的奖品');
        });
        $('.share_btn').on('click', function() {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            $('.share_popup').fadeIn();
            requestInterface.countNum('小樱_第六期_移动端_分享按钮');
        });
        $('.rule_btn').on('click', function() {
            $('.rule_popup').fadeIn();
            requestInterface.countNum('小樱_第六期_移动端_规则按钮');
        });
        $('.rule_popup .confirm_btn').on('click', function() {
            $('.rule_popup').fadeOut();
        });

        $('.cg_btn').on('click', function() {
            const idx = $(this).attr('data-idx');
            $('.cg_box').attr('class', `cg_box popup_box cg_box_${idx}`);
            $('.cg_image').hide();
            $(`.cg_${idx}`).show();
            $('.cg_popup').fadeIn();
            requestInterface.countNum('小樱_第六期_移动端_查看CG图');
        });

        $('.award_list_box .confirm_btn').on('click', function() {
            $('.award_list_popup').fadeOut();
        });
        $('.my_prize .receive_btn').on('click', function() {
            if (awardNum === 0) {
                layer.msg("没有能领取的奖品，快去祈愿吧");
                return false;
            }
            // 打开弹窗
            if (isBindRole) { // 已经绑定角色，提示奖励领取到哪个角色
                $('.reward_popup').fadeIn();
            } else { // 未绑定的让玩家绑定角色
                obj.serverInfo(config.account);
            }
            requestInterface.countNum('小樱_第六期_移动端_一键领取');
        });
        $('.lottery_btn').on('click', function() {
            if (!config.account) {
                $('.register-popup').fadeIn();
                return false;
            }
            // 防抖
            const currentTime = Date.now();
            if (currentTime - lastClickTime < cutdown) {
                layer.msg("操作太快，请稍后再试", { time: 1000 });
                return false;
            }
            lastClickTime = currentTime;

            $('.prevent-wrap').show();
            requestInterface.lottery({}, function(response) {
                if (response.code == 200) {
                    const { prize_id, title, is_prize } = response.data;
                    if (is_prize == 0) {
                        $('.un_award_popup').fadeIn();
                    } else {
                        $('.prize_popup .prop').attr('class', `prop prop_${prize_id}`);
                        $('.prize_popup .prop_name').text(title);
                        $('.prize_popup').fadeIn();
                    }
                }
            });
            requestInterface.countNum('小樱_第六期_移动端_抽奖按钮');
        });

        $('.prize_popup .close-btn, .prize_popup .confirm_btn, .un_award_popup .confirm_btn').on('click', function() {
            $('.prize_popup, .un_award_popup').fadeOut();
            obj.onInit();
        });

        // 确认领奖
        $('.bind_confirm_popup .confirm_btn, .reward_popup .confirm_btn').on('click', function() {
            requestInterface.reward({...bindParams }, function() {
                $('.my_prize_popup').fadeOut();
                $('.reward_popup').fadeOut();
                $('.bind_confirm_popup').fadeOut();
                layer.msg("领取成功", { time: 2000 });
                obj.onInit();
            });
        });
        // 确认绑定-返回
        $('.bind_confirm_popup .return_btn').on('click', function() {
            bindParams = {};
            $('.bind_confirm_popup').fadeOut();
            obj.serverInfo(config.account);
        });
        $('.reward_popup .close-reward').on('click', function() {
            $('.reward_popup').fadeOut();
        });
        $('.bind_confirm_popup .close-bind').on('click', function() {
            $('.bind_confirm_popup').fadeOut();
        });
        $('.jump_btn').on('click', function() {
            const href = $(this).data('href');
            const eventName = $(this).attr('data-event');
            if (eventName) {
                requestInterface.countNum(eventName);
            }
            if (href) {
                window.location.href = href;
            }
        });

        $('.download_btn a').click(function(event) {
            var game_id = 74;
            var query = window.location.search;
            requestInterface.countNum('小樱_第六期_移动端_下载按钮');
            $.ajax({
                type: "get",
                url: 'https://mapi.qingcigame.com/get_url?game_id=' + game_id + '',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    // 微信
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        $('.download_wrap').fadeIn();
                        return
                    };
                    if (/(Android)/i.test(navigator.userAgent)) {
                        // 安卓
                        if (json.data.android_down_url == '' || json.data.android_down_url == null) {
                            layer.msg('安卓下载暂未开放，敬请期待！', { time: 3000 });
                        } else {
                            location.href = json.data.android_down_url;
                        }
                    } else {
                        // ios
                        if (json.data.ios_down_url == '' || json.data.ios_down_url == null) {
                            layer.msg('ios下载暂未开放，敬请期待！', { time: 3000 });
                        } else {
                            location.href = json.data.ios_down_url;
                        }
                    }
                }
            });
        });
        // 关闭下载提示
        $('.download_wrap').on('click', function() {
            $('.download_wrap').fadeOut();
        });

        var codeClipboard = new Clipboard(document.querySelector(".copy_link_btn"));
        codeClipboard.on("success", function(e) {
            layer.msg("已复制至剪贴板，快分享给好友吧~");
            requestInterface.countNum('小樱_第六期_移动端_复制链接');
            return;
        });
        codeClipboard.on("error", function(e) {
            console.error("Action:", e.action);
            console.error("Trigger:", e.trigger);
        });
    },
    indexSwiper: function() {
        let mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            initialSlide: initialSlide,
            touchMoveStopPropagation: false,
            touchStartForcePreventDefault: true,

            onInit: function(swiper) {
                swiperAnimate(swiper);
                obj.ThreeSixtyJs();

                function Ani(btn, page) {
                    $(btn).on('click', function() {
                        mySwiper.slideTo(page, 1000, true);
                    });
                };

                function navLink() {
                    for (var i = 4; i >= 0; i--) {
                        Ani('.nav-link-0' + i + ' .link-a', i);
                    };
                }
                navLink();
                var aniLink01 = Ani('.arrow-b', '1');
                var aniLink02 = Ani('.arrow-b2', '2');
                var aniLink03 = Ani('.arrow-b3', '3');
                var aniLink04 = Ani('.arrow-b4', '4');

            },
            onTransitionStart: function(swiper) {
                swiperAnimate(swiper);
            },
        });

        const changeActivePage = (activeIndex) => {
            let idx = 1;
            if (activeIndex === 4) {
                idx = 5;
            } else if (activeIndex === 10) {
                idx = 1;
            } else {
                idx = activeIndex - 4;
            }
            $('.content-05 .page').attr('class', `page active_${idx}`);
        };

        let activeSwiper = new Swiper('.swiper-container2', {
            loop: true,
            effect: 'coverflow',
            paginationClickable: true,
            noSwiping: true,
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: 'auto',
            simulateTouch: false,
            // swipeHandler: '.swipe-handler',
            autoplayDisableOnInteraction: false,
            spaceBetween: 100,
            coverflow: {
                rotate: 0, // 旋转的角度
                stretch: 17.7, // 拉伸   图片间左右的间距和密集度
                depth: 30, // 深度   切换图片间上下的间距和密集度
                modifier: 10, // 修正值 该值越大前面的效果越明显
                slideShadows: false // 页面阴影效果
            },
            onSlideChangeStart: function(swiper) {
                changeActivePage(swiper.activeIndex);
            },
            onTouchEnd: function(swiper) {
                changeActivePage(swiper.activeIndex);
            },
        });

        $('.content-05 .prev_btn').on('click', function() {
            activeSwiper.slidePrev();
        });
        $('.content-05 .next_btn-2').on('click', function() {
            activeSwiper.slideNext();
        });
        $('.content-05 .page span').on('click', function() {
            const idx = $(this).data('idx');
            activeSwiper.slideTo(idx + 4);
        });

        // 卡池展示
        let roleSwiper = new Swiper('.role_list_swiper_0', {
            spaceBetween: 0,
            initialSlide: 4,
            slidesPerView: 5,
            centeredSlides: !0,
            slideToClickedSlide: true,
            onlyExternal: true,
            loop: true,
            onSlideChangeStart: function(swiper) {
                const idx = $(swiper.clickedSlide).data('idx');
                $('.level_box .role_star').hide().siblings(`.role_star_${idx}`).fadeIn(100);
                $(`.threesixty-${idx}`).fadeIn().siblings('.threesixty').fadeOut();
                $(`.content-03 .role_intro_${idx}`).fadeIn().siblings('.content-03 .role_intro_item').fadeOut();
                $('.cg_btn').attr('data-idx', idx);
            }
        });

        // 往期回顾
        function newRoleSwiper(roleName, introName) {
            new Swiper(roleName, {
                spaceBetween: 0,
                initialSlide: 4,
                slidesPerView: 5,
                centeredSlides: !0,
                slideToClickedSlide: true,
                onlyExternal: true,
                loop: true,
                onSlideChangeStart: function(swiper) {
                    const idx = $(swiper.clickedSlide).data('idx');
                    // console.log("idx", idx);
                    $(introName).find('.role_intro_item').hide();
                    $(introName).find('.role_intro_' + idx + '').fadeIn(500);
                }
            });
        }

        var roleSwiper1 = newRoleSwiper('.role_list_swiper_1', '.role_intro_box_1');
        var roleSwiper2 = newRoleSwiper('.role_list_swiper_2', '.role_intro_box_2');
        var roleSwiper3 = newRoleSwiper('.role_list_swiper_3', '.role_intro_box_3');
        var roleSwiper4 = newRoleSwiper('.role_list_swiper_4', '.role_intro_box_4');

        $('.role_intro_5').fadeIn();
        $('.level_box .role_star_5').fadeIn();
    },
    ThreeSixtyJs: function() {
        function productInfo() {
            const fontUnit = Number($('html').css('font-size').replace('px', ''));
            const width = 16.2 * fontUnit;
            const height = 28.8 * fontUnit;
            const ext = '.png';
            $('.threesixty .threesixty_images').html('');
            var product1 = $('.threesixty-1').ThreeSixty({
                totalFrames: 60,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-1',
                progress: '.spinner-1',
                imagePath: '/1/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product2 = $('.threesixty-2').ThreeSixty({
                totalFrames: 64,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-2',
                progress: '.spinner-2',
                imagePath: '/2/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product3 = $('.threesixty-3').ThreeSixty({
                totalFrames: 60,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-3',
                progress: '.spinner-3',
                imagePath: '/3/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product4 = $('.threesixty-4').ThreeSixty({
                totalFrames: 63,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-4',
                progress: '.spinner-4',
                imagePath: '/4/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            var product5 = $('.threesixty-5').ThreeSixty({
                totalFrames: 60,
                endFrame: 1,
                currentFrame: 5,
                imgList: '.threesixty_images-5',
                progress: '.spinner-5',
                imagePath: '/5/',
                filePrefix: '',
                ext: ext,
                width: width,
                height: height,
                navigation: false,
                disableSpin: false
            });
            $('.threesixty-5').fadeIn();
        }
        productInfo();
    },
    // 初始化用户信息
    onInit: function() {
        requestInterface.init({}, function(response) {
            const { data } = response;
            if (response.code == 200) {
                const { user_info, activity } = data;
                // console.log("user_info:", user_info);
                // console.log("activity:", activity);
                config.account = user_info.account;
                obj.updateHeader();
                // 更新我的奖池
                const rewardList = activity.reward_list;
                let rewardHtml = '';
                awardNum = 0;
                gameNum = activity.times;
                isBindRole = activity.is_bind == 1;
                if (isBindRole) {
                    const { role_id, role_name, server_id, server_name, platform } = activity;
                    bindParams = { role_id, role_name, server_id, server_name, platform };
                    $('.reward_popup .reward_box p span').text(`${role_name}(${server_name})`);
                } else {
                    bindParams = {};
                }
                if (activity.notice) {
                    const { account, title } = activity.notice;
                    $('.winner_box .role_name').text(account);
                    $('.winner_box .award_name').text(title);
                    $('.winner_box').show();
                } else {
                    $('.winner_box').hide();
                }
                rewardList.forEach((item) => {
                    if (item.is_send === 0) {
                        awardNum++;
                    }
                    rewardHtml += `<li class="${item.is_send === 1 ? 'reward' : ''}"><p><span>${item.remark}</span></p></li>`;
                });

                if (rewardList.length > 4) {
                    $('.my_prize_popup .more_icon').show();
                } else {
                    $('.my_prize_popup .more_icon').hide();
                }

                $('.my_prize_popup .list ul').html(rewardHtml);
                $('.content-02 .operation .number span').text(activity.times);
                const getRandomString = () => {
                    return Math.random().toString(36).slice(2);
                }
                $('.copy_link_btn').attr('data-clipboard-text', `${shareText}https://sakura.qingcijoy.com/m-card-6/enter${getRandomString()}?helper_id=${activity.user_id}`);

                // 将帮助id存储到localStorage
                var helperId = window.localStorage.getItem('helper_id') || '';
                var helperIdArr = helperId ? helperId.split(',') : [];
                if (!helperId.includes(activity.user_id)) {
                    // 如果id在缓存中不包含则进行记录
                    helperIdArr.push(activity.user_id);
                    window.localStorage.setItem('helper_id', helperIdArr.join(','));
                }
                obj.helpRecord();
            } else {
                obj.openLoginPopup();
            }
        });
    },
    // 打开登陆弹窗
    openLoginPopup: function() {
        $('.inp-account').val('');
        $('.inp-password').val('');
        $('.phone-inp').val('');
        $('input[name=sms_code]').val('');
        $('.inp-role-name').val('');
        $('.inp-role-id').val('');
        clearTimeout(timer);
        wait = 60;
        setTimeout(() => {
            $('.obtain-verification label span a').remove();
            $('.obtain-verification label span').html("<a>发送</a>");
        }, 100);
        $('.register-popup').fadeIn();
    },
    // 登陆弹窗相关事件绑定
    loginEventBind: function() {
        // 切换登陆方式
        $('.register-box .title').on('click', 'div', function(event) {
            $(this).addClass('active').siblings().removeClass('active');
            for (var i = 0; i <= 3; i++) {
                $('.form-main').removeClass('move-' + i + '')
            };
            $('.form-main').addClass('move-' + $(this).attr('data') + '')
        });
        // 登陆弹窗关闭按钮
        $('.register-popup .close-bg').on('click', function() {
            $('.register-popup').fadeOut();
        });
        // 光子服/正式服 切换
        $('.tab-server').on('click', 'div', function(event) {
            $(this).addClass('active').siblings().removeClass('active')
                .parent('.tab-server').siblings('.option-main')
                .children('.option-box').eq($(this).index())
                .addClass('show').siblings().removeClass('show');

            $('.gzf select').val('0')
            $('.gzf input[name=gzf_role_name]').val('')
            $('.zsf-os').val('')
            $('.zsf-server').val('')
            $('.zsf input[name=zsf_role_name]').val('');

            bindParams = {
                game_id: $(this).parent().find('.active').attr('data-game-id'),
                role_id: "",
                role_name: "",
                server_id: "",
                server_name: "",
                type: ""
            };
        });

        // 账户登陆
        $('.register-btn').click(function(event) {
            const account = $('.inp-account').val();
            const password = $('.inp-password').val();
            if (account == '') {
                layer.msg("请输入您的账号", { time: 2000 });
                return false;
            }
            if (password == '') {
                layer.msg("请输入您的密码", { time: 2000 });
                return false;
            }
            requestInterface.accountLogin({ account, password, is_remember: 1 }, function(response) {
                localStorage.setItem('access_token', response.data.access_token);
                $('.popup').fadeOut();
                obj.onInit();
            });
        });
        // 验证码登陆
        $('.sms-login').click(function() {
            const account = $('.phone-inp').val();
            const code = $('input[name=sms_code]').val();

            if (account == '') {
                layer.msg("请输入正确的手机号", { time: 2000 });
                return false;
            }
            if (!code) {
                layer.msg("请输入您的验证码", { time: 2000 });
                return false;
            }

            requestInterface.smsLogin({ account, sms_code: code, is_remember: 1 }, function(response) {
                localStorage.setItem('access_token', response.data.access_token);
                $('.popup').fadeOut();
                obj.onInit();
            });
        });
        // 渠道服登录 
        $('.binding-btn').click(function() {
            var roleName = $('.inp-role-name').val();
            var roleId = $('.inp-role-id').val();
            var channelName = $(".select-channel[name='channel_name']").val();

            if (roleName == "") {
                layer.msg("请输入角色名称");
                return;
            }
            if (roleId == "") {
                layer.msg("请输入角色ID");
                return;
            }
            if (channelName == "") {
                layer.msg("请选择渠道");
                return;
            }

            requestInterface.channelLogin({
                app_id: 74,
                page_id: 11,
                role_id: roleId,
                role_name: roleName,
                platform: channelName,
                dist: 74,
                game_id: 74,
                empower: 1
            }, function(response) {
                localStorage.setItem('access_token', response.data.uuid);
                // 清空填写的内容
                $('.inp-role-name').val('');
                $('.inp-role-id').val('');
                $('.popup').fadeOut();
                obj.onInit();
            });
        });

        // 验证码发送
        $('.obtain-verification').on('click', 'a', function(event) {
            const phone = $('.phone-inp');
            if (!phone.val()) {
                layer.msg("请输入手机号", { time: 2000 });
                phone.focus();
                return false;
            }
            requestInterface.sendSms(phone.val());
        });

        // 绑定角色
        $('.confirm-btn').click(function(event) {
            // console.log(bindParams);
            if (bindParams.role_id == undefined) {
                layer.msg("请先选择信息");
                return false;
            }
            // TODO: 二次确认弹窗
            $('.bind_confirm_popup .bind_confirm_box p span').text(`${bindParams.role_name}(${bindParams.server_name})`);
            $('.server-popup').fadeOut();
            $('.bind_confirm_popup').fadeIn();
        });
        $('.cancell-btn').on('click', function() {
            $('.server-popup').fadeOut();
        });

        $('.channel-cancell-btn').click(function(event) {
            obj.onLogout();
        });

        // 头部点击
        $('.header .login_btn').on('click', function() {
            obj.openLoginPopup();
            $('.register-popup').fadeIn();
            requestInterface.countNum('小樱_第六期_移动端_登陆按钮');
        });
        $('.header .logout_btn').on('click', function() {
            $('.logout-popup').fadeIn();
            requestInterface.countNum('小樱_第六期_移动端_注销按钮');
        });
        $('.logout-popup .close-bg').on('click', function() {
            $('.logout-popup').fadeOut();
        });
    },
    serverInfo: function(account) {
        // 初始化打开状态
        $('.tab-server').show();
        $('.tab-server').find('.active').removeClass('active');
        $('.tab-server').find('div:first').addClass('active');
        $('.gzf').addClass('show');
        $('.zsf').removeClass('show');
        $('input[name=gzf_role_name]').val('');
        $('input[name=zsf_role_name]').val('');

        // 初始化参数状态
        bindParams = {};

        requestInterface.getRoleList({ account: account, app_id: 74, page_id: config.page_id }, function(json) {
            var xff = json.data[61],
                zsf = json.data[74];
            if (!xff && !zsf) {
                layer.msg("查无您的角色信息")
                return false;
            } else if (!xff || !zsf) {
                $('.tab-server').hide();
            } else {
                $('.tab-server').show();
            }

            if (xff) {
                $('.gzf select').html('<option value="0">请选择区组</option>');
                var list = xff.android;
                for (var key in list) {
                    var value = list[key];
                    const jsonExtra = JSON.stringify(value['extra'])
                    $('.gzf select').append('<option data-role_id="' + value['role_id'] + '" data-role-name="' + value['role_name'] + '" data-serverId="' + value['server_id'] + '" data-platform="' + value['platform'] + '" data-extra=' + jsonExtra + ' data-server_name="' + value['server_name'] + '">' + value['server_name'] + '</option>')
                }

                $('.gzf select').off('change').on('change', function() {
                    var option = $(this).find('option:selected');
                    // console.log('option', option.val());
                    if (option.val() && option.val() != '0') {
                        // 改值
                        $('input[name=gzf_role_name]').val($(this).find('option:selected').attr('data-role-name'));
                        bindParams = {
                            game_id: 61,
                            role_id: option.attr('data-role_id'),
                            role_name: option.attr('data-role-name'),
                            server_id: option.attr('data-serverId'),
                            server_name: option.attr('data-server_name'),
                            type: "android",
                            platform: option.attr('data-platform'),
                            extra: option.attr('data-extra')
                        }
                    } else {
                        // 清空
                        $('input[name=gzf_role_name]').val('');
                        bindParams = {}
                    }
                });
            } else {
                $('.gzf').removeClass('show');
            }

            if (zsf) {
                // 如果没有光子服就显示
                xff ? $('.zsf').removeClass('show') : $('.zsf').addClass('show');

                $('.zsf-server').html('<option value="">请选择区服</option>')
                    // 初始化内容
                $('.zsf-os').html('<option value="">请选择手机系统</option>')

                // 拼接手机系统
                for (var key in zsf) {
                    $('.zsf-os').append('<option value="' + key + '">ios/安卓</option>')
                }

                // 手机系统选择
                $('.zsf-os').off('change').on('change', function() {
                    bindParams = { game_id: 74, type: $(this).val() };
                    var role = zsf[$(this).val()];
                    // 区服下拉框设置为空
                    $('.zsf-server').html('<option value="">请选择区服</option>');
                    // 角色信息为空
                    $('.zsf-role').val('');
                    // 拼接区服下拉框
                    for (var key in role) {
                        var value = role[key];
                        const jsonExtra = JSON.stringify(value['extra'])
                            // console.log(jsonExtra)
                        $('.zsf-server').append('<option data-role_id="' + value['role_id'] + '" data-role-name="' + value['role_name'] + '" data-serverId="' + value['server_id'] + '" data-platform="' + value['platform'] + '" data-extra=' + jsonExtra + ' data-server_name="' + value['server_name'] + '">' + value['server_name'] + '</option>')
                    }

                    // 响应区服下拉框事件
                    $('.zsf-server').on('change', function() {
                        var option = $(this).find('option:selected');
                        if (option.val()) {
                            $('.zsf-role').val(option.attr('data-role-name'))
                            bindParams.role_id = option.attr('data-role_id')
                            bindParams.role_name = option.attr('data-role-name')
                            bindParams.server_id = option.attr('data-serverId')
                            bindParams.server_name = option.attr('data-server_name')
                            bindParams.platform = option.attr('data-platform'),
                                bindParams.extra = option.attr('data-extra')
                        } else {
                            $('.zsf-role').val('');
                            bindParams = { game_id: 74, type: $(this).val() }
                        }
                    });
                });
            } else {
                $('.zsf').removeClass('show');
            }

            $('.inp-account').val(''); // 账号密码清空
            $('.inp-password').val(''); // 账号密码清空
            $('.register-popup').fadeOut(); // 关闭登陆页面
            $('.server-popup').fadeIn(); // 开启服务器
        });
    },
    updateHeader: function() {
        if (config.account) {
            $('.header .info .intro').text(config.account);
            $('.header .login_btn').hide();
            $('.header .logout_btn').show();
        } else {
            $('.header .info .intro').text('请先登录');
            $('.header .login_btn').show();
            $('.header .logout_btn').hide();

        }
    },
    onLogout: function() {
        requestInterface.logout(function(json) {
            if (json.code == 200) {
                $('#account').html('请先登录');
                $('#server_name').html('');
                $('#role_name').html('');
                config.role_id = '';
                config.account = '';
                awardNum = 0;
                gameNum = 0;
                isBindRole = false;
                bindParams = {};

                obj.updateHeader();
                $('.content-02 .operation .number span').text(0);
                $('.my_prize_popup .list ul').html('');
                localStorage.setItem('token', '');
                localStorage.setItem('access_token', '');
            }
        });
        $('.popup').fadeOut();
    },
    // 微信分享
    share: function() {
        var share_icon = 'https://download4.qcplay.com/qcgame-admin/dnX29EuzSenmU1Vt8cDJvCOGHofjdxkHtEs0Lzhm.png'
        var share_big_title = '《魔卡少女樱：回忆钥匙》梦幻卡池「暖意新春」';
        var share_min_title = '瑞雪兆丰，暖意新春。完成祈愿任务，有机会抽取「暖意新春」全套满阶卡池，快来看看吧！';
        var share_link = window.location.href;
        outside.share(share_icon, share_big_title, share_min_title, share_link);
    },
}

requestInterface = {
    is_login: function(is_token) {
        const index = layer.load(1);
        $.ajax({
            url: api + "/cherry/auth/login",
            type: "POST",
            xhrFields: { withCredentials: true },
            data: { token: is_token },
            success: function(json) {
                if (json.code != 200) {
                    return false;
                }
                localStorage.setItem('access_token', json.data.access_token);
                setTimeout(function() {
                    obj.onInit();
                }, 100);
                // callback && callback(json);
            },
            complete: function() {
                layer.close(index)
            }
        });
    },
    accountLogin: function(data, callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + "/snail/login/account",
            type: "POST",
            xhrFields: { withCredentials: true },
            data,
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index)
            }
        });
    },
    smsLogin: function(data, callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + '/snail/login/sms',
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    channelLogin: function(data, callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + '/game/binds/channel',
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    sendSms: function(phone) {
        const index = layer.load(1);
        $.ajax({
            url: api + '/login/lt/code/dispatch',
            type: "POST",
            data: { mobile: phone, channel: "login" },
            xhrFields: { withCredentials: true },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                } else {
                    // 倒计时
                    time();
                }
            },
            complete: function() {
                layer.close(index);
            }
        });
    },
    logout: function(callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + "/cherry/draw/logout",
            type: "POST",
            data: { key: activeKey },
            xhrFields: { withCredentials: true },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                } else {
                    layer.msg('注销成功');
                }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
            }
        });
    },
    getRoleList: function(data, callback) {
        const index = layer.load(1);
        $.ajax({
            url: api + "/game/server",
            type: "GET",
            xhrFields: { withCredentials: true },
            data,
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
            }
        });
    },

    // 业务接口
    init: function(data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: api + '/cherry/draw/init',
            type: "GET",
            data,
            xhrFields: { withCredentials: true },
            success: function(json) {
                if (json.code != 200) {
                    if (json.message !== '很抱歉,请先登录') layer.msg(json.message);
                } else {
                    localStorage.setItem('token', json.data.activity.token);
                    localStorage.setItem('access_token', json.data.activity.access_token);
                }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
            }
        });
    },
    share: function(data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: api + "/cherry/draw/share",
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function(json) {
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
            }
        });
    },
    lottery: function(data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: api + "/cherry/draw/lottery",
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                // {
                //   "code": 200,
                //   "message": "ok",
                //   "data": {
                //     "prize_id": 1,
                //     "is_good": 0
                //   }
                // }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
                $('.prevent-wrap').hide();
            }
        });
    },
    reward: function(data = {}, callback) {
        data.key = activeKey;
        data.token = localStorage.getItem('token') || '';
        data.access_token = localStorage.getItem('access_token') || '';
        const index = layer.load(1);
        $.ajax({
            url: api + "/cherry/draw/reward",
            type: "POST",
            data,
            xhrFields: { withCredentials: true },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return false;
                }
                callback && callback(json);
            },
            complete: function() {
                layer.close(index);
                $('.prevent-wrap').hide();
            }
        });
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    },
};

// 验证码倒计时
function time() {
    if (wait == 0) {
        $('.obtain-verification label span a').remove();
        $('.obtain-verification label span').html("<a>发送</a>");
        wait = 60;
    } else {
        $('.obtain-verification label span a').remove();
        $('.obtain-verification label span').html("<b>" + wait + "秒</b>");
        wait--;
        timer = setTimeout(function() {
            time()
        }, 1000);
    }
}

function analysisParams(url) {
    const params = {};
    const paramsString = url.split('?')[1];
    if (!paramsString) {
        return params;
    }
    const str = paramsString.split('&');
    for (let idx = 0; idx < str.length; idx++) {
        const values = str[idx].split('=');
        params[values[0]] = values[1];
    }
    return params;
};